var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 523.951,
    height: 400
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1121",
    transform: "translate(-383.001 -376.525)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1170",
    cx: 243.153,
    cy: 10.458,
    rx: 243.153,
    ry: 10.458,
    transform: "translate(402.871 755.608)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1120",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.193 608.271s-13.906 12.351-18.385 27.45 31.316 95.175 31.316 95.175l8.107-2.92-13.045-87.456 40-11.59-1.006 97.836h9.411l16.178-88.39 45.094 1.471-5.156-40.2-112.514 8.624",
    fill: "#00cd74"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M771.743 599.631s-2.255-92.4-23.19-102.061a201.8 201.8 0 00-21.452-8.428c-1.857 10.324-45.267 11.319-44.2-.58a37.637 37.637 0 00-19.377 18.986c-9.663 21.572-24.478 59.518-24.478 59.518l-19.647-55.652-9.019 4.834s11.38 83.392 30.812 83.392 32.96-24.665 32.96-24.665v24.661h97.59",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M706.038 509.16c12.187-.975 19.205-9.7 21.062-20.019a209.187 209.187 0 00-5.765-1.8c-1.36 4.118-33.147 3.226-33.438-.719a48 48 0 00-5 1.935c-1.064 11.9 11.305 20.6 23.141 20.6",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M745.976 540.261l3.221 52.5h6.764l-9.985-52.5",
    fill: "#ff516c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M718.541 486.547a9.1 9.1 0 01-6.643-7.906l-1.377-14.51-2.471-23.226-12.317-1.127s-7.086.361-7.086 7.263-2.416 24.027 1.288 25.929 4.255 1.757 4.255 1.757l1.311 10.09a48.538 48.538 0 00-7.6 1.81c-.46 21.409 32.977 22.128 33.438.718q-1.484-.437-2.8-.8",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M708.049 440.905c.581-5.16-3.689-6.851-9.1-7.727 0 0-.966-5.312-4.34-6.922s-10.475-.483-8.831 9.5 22.268 5.151 22.268 5.151-5.231.322-4.587 8.371.966 11.807.966 11.807l3.7 4.513h2.745c1.679-11.444 3.814-23.448-2.821-24.691",
    fill: "#fff03d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M704.285 461.241s4.375-4.77 5.883-2.653-3.451 6.642-3.451 6.642",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M690.464 464.308h4.187s.483-8.45-1.128-8.835-3.06 8.835-3.06 8.835M705.042 463.727a.322.322 0 01-.207-.569l4.036-3.369a.322.322 0 01.413.495l-4.036 3.368a.32.32 0 01-.206.075",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M700.355 455.283a1.3 1.3 0 10-1.3 1.3 1.3 1.3 0 001.3-1.3M690.464 455.133a1.3 1.3 0 10-1.3 1.3 1.3 1.3 0 001.3-1.3M687.872 451.944a.482.482 0 01-.419-.722 2.61 2.61 0 011.922-1.326 2.364 2.364 0 012 .681.483.483 0 11-.685.681 1.387 1.387 0 00-1.19-.4 1.653 1.653 0 00-1.21.847.483.483 0 01-.42.244M701.371 451.849a.482.482 0 01-.342-.142 3.1 3.1 0 00-3.9-.3.483.483 0 11-.572-.779 4.1 4.1 0 015.16.394.483.483 0 01-.342.824",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M694.189 474.727l6.166.949-5.974 1.614-.193-2.563M695.5 484.816l.447 4.7-2.459-4.349 2.013-.355",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M639.045 567.068l6.442 11.85-3.221-20.023-3.221 8.173",
    fill: "#ff516c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M619.415 511.616l-2.253-8.366s6.12-4.026 5.636-5.154-8 2.735-8 2.735-5.529-12.382-6.656-12.067 3.22 11.423 3.22 11.423-8.374-9.177-9.34-8.532 5.8 9.82 5.8 9.82-10.79-5.8-10.951-4.99 8.374 6.766 8.374 6.766-9.02-2.421-9.183-1.294 10.951 5.956 10.951 5.956l3.382 8.532 9.018-4.829",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M692.176 468.618q-.685 0-1.4-.059a.322.322 0 01-.3-.347.329.329 0 01.348-.295 13.546 13.546 0 004.827-.4.322.322 0 01.173.62 13.518 13.518 0 01-3.65.48M614.631 500.343l.3.569-6.657 3.541-.3-.568 6.657-3.542M654.124 730.896l3.6 8.4-6.764 5.395 13.312-3.594-2.039-13.116-8.111 2.92M688.179 726.764v9.362l-5.331 3.984 11.951-.82 2.791-12.529h-9.411",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M402.218 571.491s3.48 83.263 36.883 86.491",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.212 756.751l-1.035 3.57a3.338 3.338 0 013.945-.645 4.644 4.644 0 012.277 5.4c-1.924 5.947-9.04 2.552-9.748-2.069a34.9 34.9 0 01.956-6.149 86.75 86.75 0 01-7.664-.234c-2.232-.171-4.658-.308-6.426-1.626a4.3 4.3 0 01-1.985-2.66l-8.75 2.146a4.937 4.937 0 014.476 3.875c.47 3.193-3.165 6.207-6.217 5.156-2.988-1.029-4.262-5.092-2.845-7.916 1.568-3.125 11.946-5.567 16.7-7.04a22.641 22.641 0 012.327-.965l.043-.081a.19.19 0 01-.04.08 67.6 67.6 0 0113.525-2.889v-83.171h5.714v82.623a57.775 57.775 0 0111.683.154c2.978.469 6.543 1.981 7.375 4.428 4.969 1.488 14.613 3.86 16.12 6.864 1.417 2.824.144 6.887-2.845 7.916-3.052 1.051-6.687-1.963-6.217-5.156a4.937 4.937 0 014.476-3.875l-11.817-2.9c-1.13 2.015-4.114 2.858-6.645 3.254a161.714 161.714 0 01-17.383 1.91z",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M438.515 639.898s-21.725 26.244 14.326 28.692 71.967-28.692 71.967-28.692h-86.293M414.662 509.712c-10.92.66-20.8 7.357-26.132 16.13s-6.49 19.33-4.82 29.26c1.535 9.129 5.521 18.129 12.65 24.647s17.663 10.218 27.506 8.31l-9.204-78.347",
    fill: "#403f3f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M539.773 754.277l27.441-63.913 14.736-60.719h-54.377l25.916-33.479s80.374-11.008 77.284 25.766-66.1 102.545-77.283 124.454l13.721 7.891h-27.438",
    fill: "#ffaaa0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M525.033 655.121l38.621-6.861-56.415 115.82h25.1l-11.369-9.32s97.176-99.895 88.224-123.262-22.926-27.939-64.341-22.35l-19.82 45.973",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M438.197 648.41s24.84 24.234 86.836 6.709l43.448-64.962h-95.9l-34.384 58.253",
    fill: "#fff03d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M509.534 507.678l8.385 39.241h64.029l-.409 9.081s-82.167 12.781-88.9 9.655-7.495-54.017-9.782-55.425 26.679-2.551 26.679-2.551",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M507.239 498.408l2.295 9.271-19.056 5.182-3.811-8.992 20.573-5.461",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M456.812 456.881s-28.074 2.794-41.034 51.56-5.851 110.634 22.419 139.973l43.134-58.745h22.107l-8.385-61.795s7.623-9.271 1.525-26.161l10.663-3.3s-3.803-32.899-16.382-36.579l-34.047-4.953",
    fill: "#00cd74"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M539.769 562.099l15.753-67.561 39.128 8.381-15.5 62.735-39.383-3.556",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M544.851 566.984l15.753-67.562 39.128 8.382-15.5 62.735-39.383-3.556",
    fill: "#a7deff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M481.714 401.778a24.465 24.465 0 017.489 15.863 9.669 9.669 0 003.43 7.111 3.355 3.355 0 01-2.159 2.921s1.779 10.414-.635 11.3-6.479 2.793-6.479 2.793l-.377 13.465 7.876 6.6s-23.756 12.322-34.047-4.949c0 0 8.131-3.3 8.766-5.969s.89-10.667.89-10.667l-3.43-11.556s5.082-19.43 5.208-19.049 13.468-7.863 13.468-7.863",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M456.812 402.909s-4.701-7.112-12.958-4.953-10.925 9.652-9.656 19.811-3.053 29.589-3.053 29.589l19.442-2.158 5.717-26.8.508-15.493",
    fill: "#ff516c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M466.467 440.245s5.717-4.191 4.573-9.525c0 0-7.622-3.556-4.573-7.62s7.622 3.3 7.622 3.3 2.832-7.321 5.463-9.525c4.7-3.936 6.351-13.969-.635-17.017s-26.424-5.331-29.728 11.433 14.991 23.112 17.278 28.954",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M552.219 509.578l.625-3.556-8.247 9.144-57.931 38.582-16.777-45.113-31.692 13.416c7.687 18.846 26.051 60.181 39.576 61.067 17.532 1.149 74.192-62.359 74.192-62.359l9.909-1.779 6.605-8.381-16.26-1.021",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M466.086 498.408l-31.506 14.453s1.34 3.609 3.617 9.191l31.693-13.416-3.8-10.227",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M486.666 553.749l-7.622 4.854 5.953-9.344 1.669 4.49",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M581.947 559.873l1.271-11.16 8.639-1.794-1.778 12.954h-8.131",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M484.803 420.717a1.736 1.736 0 10-1.736 1.736 1.736 1.736 0 001.736-1.736M480.377 417.004a.571.571 0 01-.343-1.029 4.653 4.653 0 015.457-.012.572.572 0 11-.683.917 3.536 3.536 0 00-4.089.009.567.567 0 01-.342.114",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M472.58 428.989a.379.379 0 01-.252-.1l-4.474-3.921a.381.381 0 11.5-.572l4.472 3.926a.381.381 0 01-.252.667",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M516.789 744.475l-9.549 19.6h25.1l-11.37-9.32s3.779-3.885 9.762-10.285h-13.943M548.052 734.986l-8.283 19.291h27.438l-13.721-7.89a97.709 97.709 0 017.308-11.4h-12.742",
    fill: "#00cd74"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M489.775 433.557a6.711 6.711 0 01-3.259-.856.381.381 0 11.368-.667 5.907 5.907 0 003.642.712.381.381 0 11.1.755 6.454 6.454 0 01-.848.056",
    fill: "#ff7381"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M821.351 387.322s-5.945-1.486-12.385 5.447a149.589 149.589 0 00-9.909 11.638l3.22 3.961 1.487 10.647 8.533 2.972 1.871 14.855 23.284-4.457-3.221-18.076.991-17.581-13.871-9.406",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M827.544 392.274s-7.431-.247-9.908 6.191-9.66 16.589-15.357 9.9c0 0-17.587 10.718-15.11 20.622s11.25 13.018 21.956 7.586 14.952-30.437 14.952-30.437 5.945-4.952 7.926-.991-6.193 7.924-6.193 7.924l.247 6.933 8.918-2.476s9.908-23.028 0-29.218-11.89-12.871-17.339-11.634-9.908 11.638 9.908 15.6",
    fill: "#19243c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M801.287 407.873s7.038 2.8 5.264 16.59c0 0-12.2-9.9-5.264-16.59",
    fill: "#2e3a54"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M813.425 398.588a1.858 1.858 0 10-1.858 1.857 1.858 1.858 0 001.858-1.857",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M824.508 410.193a.408.408 0 01-.285-.7 11.066 11.066 0 015.19-2.845.408.408 0 01.186.795 10.248 10.248 0 00-4.806 2.635.408.408 0 01-.285.116",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M816.039 396.854a.612.612 0 01-.61-.573 2.824 2.824 0 00-3.575-2.327.612.612 0 01-.423-1.149 4.043 4.043 0 015.22 3.4.613.613 0 01-.572.65h-.04",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined-Shape",
    d: "M810.624 749.43l-1.036 3.569a3.339 3.339 0 013.946-.645 4.644 4.644 0 012.276 5.4c-1.923 5.946-9.039 2.551-9.747-2.07a34.887 34.887 0 01.955-6.149 86.738 86.738 0 01-7.663-.234c-2.232-.17-4.657-.308-6.426-1.626a4.3 4.3 0 01-1.985-2.659l-8.75 2.146a4.934 4.934 0 014.476 3.874c.47 3.193-3.164 6.207-6.216 5.156-2.989-1.029-4.262-5.091-2.845-7.916 1.568-3.125 11.946-5.567 16.7-7.04a22.7 22.7 0 012.328-.965l.043-.081a.2.2 0 01-.04.08 70.558 70.558 0 0114.84-3.044l3.106-89.134 3.234.568a51.086 51.086 0 0028.789-5.426c20.078-10.157 33.937-33.136 40.079-66.449l5.619 1.035c-8.225 44.616-28.16 63.056-43.435 70.67a58 58 0 01-28.8 6.13l-2.861 82.128a53.779 53.779 0 0110.348.236c2.978.47 6.543 1.981 7.374 4.428 4.971 1.488 14.613 3.861 16.12 6.864 1.417 2.824.143 6.887-2.845 7.916-3.052 1.051-6.687-1.963-6.216-5.156a4.934 4.934 0 014.476-3.874l-11.817-2.9c-1.13 2.015-4.114 2.858-6.645 3.255a161.894 161.894 0 01-17.382 1.913z",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M853.399 534.749a49.463 49.463 0 0121.663-6.694c10.131-.628 20.943 3.033 26.961 11.2 6.831 9.274 5.743 24.162 1.683 34.39-10.844 27.323-59.336 12.548-63.936-12.918-2.113-11.7 4.458-20.475 13.624-25.982M775.22 640.05s13.009 17.672 39.537 19 55.965-7.573 33.109-29.6c-24.226-23.353-72.647 10.6-72.647 10.6",
    fill: "#403f3f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M637.846 513.612l23.233 56.685h118.086l-18.638-8.715-28.3-1.637-21.319-47.875a7.884 7.884 0 00-7.433-4.672l-62.789 1.84a3.172 3.172 0 00-2.844 4.373",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M664.295 559.944h62.492l-20.807-46.428-60.924 1.4 19.237 45.028",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M757.999 731.388l5.436 13.5-13.309 7.237 25.3-.569-2.978-20.168h-14.449",
    fill: "#0657cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M758.898 733.481s-42.857-92.066-43.265-114.1 40.816 8.024 40.816 8.024l16.325 106.074h-13.876",
    fill: "#2e3a54"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M847.867 629.447s-36.731 41.613-159.17-10.608l30.2 119.946h-13.875s-62.852-108.522-44.894-141.976 122.983-12.49 122.983-12.49l64.756 45.129",
    fill: "#19243c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M847.866 629.447l-51.312-35.76-21.334-10.771-6.121 1.653 60.128 55.482c13.319-4.586 18.64-10.6 18.64-10.6",
    fill: "#2e3a54"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M506.673 768.158h13.875V578.011h-13.875zM723.796 768.158h13.876V578.011h-13.876z",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M464.226 584.318h329.768v-14.022H464.226z",
    fill: "#a7deff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M710.914 551.789l-13.74-3.255-17.825 5.175v4.017l13.426.188 8.341 3.666 9.8-9.792",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M699.307 560.614l9.8-9.794 66.117 11.715s8.979-120.761 44.894-131.368 59.587 5.712 68.566 42.429 8.979 117.5-40.813 169.718l-71.014-52.22s-42.094-10.312-77.545-30.482",
    fill: "#0657cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M786.238 564.17l-10.407-8.452-.612 6.82zM836.44 495.058s-12.516 102.021-59.587 96.038l13.68 10.059s45.091-16.913 45.907-106.1",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M688.697 618.839l-13.876-5.715 16.775 17.228-2.9-11.516",
    fill: "#2e3a54"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M705.022 738.784l6.122 12.647-12.244 7.344h24.9l-4.9-19.991h-13.878",
    fill: "#0657cd"
  }))))));
}
export default SvgFamily;